// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cursor-pointer {
  cursor: pointer;
}

.border-left-primary {
  border-left: 0.25rem solid #4e73df !important;
}

.border-left-success {
  border-left: 0.25rem solid #1cc88a !important;
}

.border-left-info {
  border-left: 0.25rem solid #36b9cc !important;
}

.border-left-warning {
  border-left: 0.25rem solid #f6c23e !important;
}

.border-left-secondary {
  border-left: 0.25rem solid #858796 !important;
}

.text-gray-300 {
  color: #dddfeb !important;
}

.text-gray-800 {
  color: #5a5c69 !important;
}

.progress-sm {
  height: 0.5rem;
}

.badge {
  font-size: 0.875em;
}
.badge.badge-success {
  background-color: #1cc88a;
  color: white;
}
.badge.badge-warning {
  background-color: #f6c23e;
  color: #1f2937;
}
.badge.badge-danger {
  background-color: #e74a3b;
  color: white;
}
.badge.badge-info {
  background-color: #36b9cc;
  color: white;
}
.badge.badge-primary {
  background-color: #4e73df;
  color: white;
}
.badge.badge-secondary {
  background-color: #858796;
  color: white;
}
.badge.badge-light {
  background-color: #f8f9fc;
  color: #1f2937;
  border: 1px solid #e3e6f0;
}
.badge.badge-dark {
  background-color: #1f2937;
  color: white;
}

.table th {
  border-top: none;
  font-weight: 600;
  font-size: 0.875rem;
  color: #5a5c69;
  vertical-align: middle;
}
.table th.cursor-pointer {
  -webkit-user-select: none;
          user-select: none;
}
.table th.cursor-pointer:hover {
  background-color: #f8f9fc;
}
.table td {
  vertical-align: middle;
  font-size: 0.875rem;
}
.table.table-hover tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.025);
}

.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
.modal.show .modal-dialog {
  transform: none;
}

.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: 0.5;
}

.alert {
  border: none;
  border-radius: 0.35rem;
}
.alert.alert-success {
  background-color: #d1ecf1;
  border-color: #bee5eb;
  color: #0c5460;
}
.alert.alert-warning {
  background-color: #fff3cd;
  border-color: #ffeaa7;
  color: #856404;
}
.alert.alert-danger {
  background-color: #f8d7da;
  border-color: #f5c6cb;
  color: #721c24;
}
.alert.alert-info {
  background-color: #d1ecf1;
  border-color: #bee5eb;
  color: #0c5460;
}

.form-control.form-control-sm {
  font-size: 0.875rem;
  border-radius: 0.2rem;
}
.form-control:focus {
  border-color: #4e73df;
  box-shadow: 0 0 0 0.2rem rgba(78, 115, 223, 0.25);
}

.btn {
  font-weight: 500;
  border-radius: 0.35rem;
}
.btn.btn-sm {
  font-size: 0.875rem;
}
.btn:focus {
  box-shadow: 0 0 0 0.2rem rgba(78, 115, 223, 0.25);
}

.spinner-border.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

.card {
  border: 1px solid #e3e6f0;
  border-radius: 0.35rem;
}
.card .card-header {
  background-color: #f8f9fc;
  border-bottom: 1px solid #e3e6f0;
  font-weight: 600;
}
.card.shadow {
  box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15) !important;
}
.card.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(58, 59, 69, 0.075) !important;
}

.nav-tabs {
  border-bottom: 1px solid #e3e6f0;
}
.nav-tabs .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 0.35rem;
  border-top-right-radius: 0.35rem;
  color: #858796;
  font-weight: 500;
}
.nav-tabs .nav-link:hover {
  border-color: #e3e6f0 #e3e6f0 #e3e6f0;
  color: #5a5c69;
}
.nav-tabs .nav-link.active {
  color: #5a5c69;
  background-color: #fff;
  border-color: #e3e6f0 #e3e6f0 #fff;
}

@media (max-width: 768px) {
  .table-responsive {
    font-size: 0.8rem;
  }
  .card-body {
    padding: 1rem;
  }
  .modal-dialog {
    margin: 0.5rem;
  }
}
@media print {
  .btn, .pagination, .modal, .card-header .spinner-border {
    display: none !important;
  }
  .card {
    border: 1px solid #000;
    box-shadow: none;
  }
  .badge {
    border: 1px solid #000;
  }
}`, "",{"version":3,"sources":["webpack://./projects/remarq/src/app/components/admin/admin-search-stats/search-analytics-main.component.scss"],"names":[],"mappings":"AAGA;EACE,eAAA;AAFF;;AAMA;EACE,6CAAA;AAHF;;AAMA;EACE,6CAAA;AAHF;;AAMA;EACE,6CAAA;AAHF;;AAMA;EACE,6CAAA;AAHF;;AAMA;EACE,6CAAA;AAHF;;AAOA;EACE,yBAAA;AAJF;;AAOA;EACE,yBAAA;AAJF;;AAQA;EACE,cAAA;AALF;;AASA;EACE,kBAAA;AANF;AAQE;EACE,yBAAA;EACA,YAAA;AANJ;AASE;EACE,yBAAA;EACA,cAAA;AAPJ;AAUE;EACE,yBAAA;EACA,YAAA;AARJ;AAWE;EACE,yBAAA;EACA,YAAA;AATJ;AAYE;EACE,yBAAA;EACA,YAAA;AAVJ;AAaE;EACE,yBAAA;EACA,YAAA;AAXJ;AAcE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAZJ;AAeE;EACE,yBAAA;EACA,YAAA;AAbJ;;AAmBE;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,sBAAA;AAhBJ;AAkBI;EACE,yBAAA;UAAA,iBAAA;AAhBN;AAkBM;EACE,yBAAA;AAhBR;AAqBE;EACE,sBAAA;EACA,mBAAA;AAnBJ;AAsBE;EACE,sCAAA;AApBJ;;AA0BE;EACE,mCAAA;EACA,8BAAA;AAvBJ;AA0BE;EACE,eAAA;AAxBJ;;AA6BE;EACE,UAAA;AA1BJ;AA6BE;EACE,YAAA;AA3BJ;;AAgCA;EACE,YAAA;EACA,sBAAA;AA7BF;AA+BE;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;AA7BJ;AAgCE;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;AA9BJ;AAiCE;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;AA/BJ;AAkCE;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;AAhCJ;;AAsCE;EACE,mBAAA;EACA,qBAAA;AAnCJ;AAsCE;EACE,qBAAA;EACA,iDAAA;AApCJ;;AAyCA;EACE,gBAAA;EACA,sBAAA;AAtCF;AAwCE;EACE,mBAAA;AAtCJ;AAyCE;EACE,iDAAA;AAvCJ;;AA6CE;EACE,WAAA;EACA,YAAA;AA1CJ;;AA+CA;EACE,yBAAA;EACA,sBAAA;AA5CF;AA8CE;EACE,yBAAA;EACA,gCAAA;EACA,gBAAA;AA5CJ;AA+CE;EACE,iEAAA;AA7CJ;AAgDE;EACE,iEAAA;AA9CJ;;AAmDA;EACE,gCAAA;AAhDF;AAkDE;EACE,6BAAA;EACA,+BAAA;EACA,gCAAA;EACA,cAAA;EACA,gBAAA;AAhDJ;AAkDI;EACE,qCAAA;EACA,cAAA;AAhDN;AAmDI;EACE,cAAA;EACA,sBAAA;EACA,kCAAA;AAjDN;;AAuDA;EACE;IACE,iBAAA;EApDF;EAuDA;IACE,aAAA;EArDF;EAwDA;IACE,cAAA;EAtDF;AACF;AA0DA;EACE;IACE,wBAAA;EAxDF;EA2DA;IACE,sBAAA;IACA,gBAAA;EAzDF;EA4DA;IACE,sBAAA;EA1DF;AACF","sourcesContent":["// Search Analytics Component Styles\n\n// Custom cursor pointer for sortable columns\n.cursor-pointer {\n  cursor: pointer;\n}\n\n// Enhanced card styles\n.border-left-primary {\n  border-left: 0.25rem solid #4e73df !important;\n}\n\n.border-left-success {\n  border-left: 0.25rem solid #1cc88a !important;\n}\n\n.border-left-info {\n  border-left: 0.25rem solid #36b9cc !important;\n}\n\n.border-left-warning {\n  border-left: 0.25rem solid #f6c23e !important;\n}\n\n.border-left-secondary {\n  border-left: 0.25rem solid #858796 !important;\n}\n\n// Text colors for consistency\n.text-gray-300 {\n  color: #dddfeb !important;\n}\n\n.text-gray-800 {\n  color: #5a5c69 !important;\n}\n\n// Progress bar enhancements\n.progress-sm {\n  height: 0.5rem;\n}\n\n// Badge enhancements\n.badge {\n  font-size: 0.875em;\n\n  &.badge-success {\n    background-color: #1cc88a;\n    color: white;\n  }\n\n  &.badge-warning {\n    background-color: #f6c23e;\n    color: #1f2937;\n  }\n\n  &.badge-danger {\n    background-color: #e74a3b;\n    color: white;\n  }\n\n  &.badge-info {\n    background-color: #36b9cc;\n    color: white;\n  }\n\n  &.badge-primary {\n    background-color: #4e73df;\n    color: white;\n  }\n\n  &.badge-secondary {\n    background-color: #858796;\n    color: white;\n  }\n\n  &.badge-light {\n    background-color: #f8f9fc;\n    color: #1f2937;\n    border: 1px solid #e3e6f0;\n  }\n\n  &.badge-dark {\n    background-color: #1f2937;\n    color: white;\n  }\n}\n\n// Table enhancements\n.table {\n  th {\n    border-top: none;\n    font-weight: 600;\n    font-size: 0.875rem;\n    color: #5a5c69;\n    vertical-align: middle;\n\n    &.cursor-pointer {\n      user-select: none;\n\n      &:hover {\n        background-color: #f8f9fc;\n      }\n    }\n  }\n\n  td {\n    vertical-align: middle;\n    font-size: 0.875rem;\n  }\n\n  &.table-hover tbody tr:hover {\n    background-color: rgba(0, 0, 0, 0.025);\n  }\n}\n\n// Modal enhancements\n.modal {\n  &.fade .modal-dialog {\n    transition: transform 0.3s ease-out;\n    transform: translate(0, -50px);\n  }\n\n  &.show .modal-dialog {\n    transform: none;\n  }\n}\n\n.modal-backdrop {\n  &.fade {\n    opacity: 0;\n  }\n\n  &.show {\n    opacity: 0.5;\n  }\n}\n\n// Alert enhancements\n.alert {\n  border: none;\n  border-radius: 0.35rem;\n\n  &.alert-success {\n    background-color: #d1ecf1;\n    border-color: #bee5eb;\n    color: #0c5460;\n  }\n\n  &.alert-warning {\n    background-color: #fff3cd;\n    border-color: #ffeaa7;\n    color: #856404;\n  }\n\n  &.alert-danger {\n    background-color: #f8d7da;\n    border-color: #f5c6cb;\n    color: #721c24;\n  }\n\n  &.alert-info {\n    background-color: #d1ecf1;\n    border-color: #bee5eb;\n    color: #0c5460;\n  }\n}\n\n// Form control enhancements\n.form-control {\n  &.form-control-sm {\n    font-size: 0.875rem;\n    border-radius: 0.2rem;\n  }\n\n  &:focus {\n    border-color: #4e73df;\n    box-shadow: 0 0 0 0.2rem rgba(78, 115, 223, 0.25);\n  }\n}\n\n// Button enhancements\n.btn {\n  font-weight: 500;\n  border-radius: 0.35rem;\n\n  &.btn-sm {\n    font-size: 0.875rem;\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 0.2rem rgba(78, 115, 223, 0.25);\n  }\n}\n\n// Spinner enhancements\n.spinner-border {\n  &.spinner-border-sm {\n    width: 1rem;\n    height: 1rem;\n  }\n}\n\n// Card enhancements\n.card {\n  border: 1px solid #e3e6f0;\n  border-radius: 0.35rem;\n\n  .card-header {\n    background-color: #f8f9fc;\n    border-bottom: 1px solid #e3e6f0;\n    font-weight: 600;\n  }\n\n  &.shadow {\n    box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15) !important;\n  }\n\n  &.shadow-sm {\n    box-shadow: 0 0.125rem 0.25rem rgba(58, 59, 69, 0.075) !important;\n  }\n}\n\n// Navigation enhancements\n.nav-tabs {\n  border-bottom: 1px solid #e3e6f0;\n\n  .nav-link {\n    border: 1px solid transparent;\n    border-top-left-radius: 0.35rem;\n    border-top-right-radius: 0.35rem;\n    color: #858796;\n    font-weight: 500;\n\n    &:hover {\n      border-color: #e3e6f0 #e3e6f0 #e3e6f0;\n      color: #5a5c69;\n    }\n\n    &.active {\n      color: #5a5c69;\n      background-color: #fff;\n      border-color: #e3e6f0 #e3e6f0 #fff;\n    }\n  }\n}\n\n// Responsive adjustments\n@media (max-width: 768px) {\n  .table-responsive {\n    font-size: 0.8rem;\n  }\n\n  .card-body {\n    padding: 1rem;\n  }\n\n  .modal-dialog {\n    margin: 0.5rem;\n  }\n}\n\n// Print styles\n@media print {\n  .btn, .pagination, .modal, .card-header .spinner-border {\n    display: none !important;\n  }\n\n  .card {\n    border: 1px solid #000;\n    box-shadow: none;\n  }\n\n  .badge {\n    border: 1px solid #000;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
